import { SalesOrderDTO, Permission, DocumentType, PrintDocumentOptionsDTO } from 'core/api';
import { Preconditions } from 'core/infrastructure-next';
import { Command } from 'pos/common';
import { printDocument } from 'pos/modules/helpers/document-printing';
import { InvoiceFacade, PrintFacade } from 'pos/facades';


export async function createPrintDocumentOptions(order: SalesOrderDTO): Promise<PrintDocumentOptionsDTO> {
	if (order.IsInvoiced) {
		const invoice = await InvoiceFacade.getById(order.TicketId);
		return PrintFacade.getPrintOptions(invoice.Type);
	}

	return PrintFacade.getPrintOptions(DocumentType.SalesOrder);
}

export async function printOrder(order: SalesOrderDTO, params: PrintFacade.PrintParams) {
	if (order.IsInvoiced) {
		const invoice = await InvoiceFacade.getByTicketId(order.TicketId);
		await PrintFacade.printInvoiceOnPrinter(invoice.Id, params);
		return;
	}

	await PrintFacade.printSalesOrderOnPrinter(order.Id, params);
}

declare global {
	interface CommandType {
		printTakeOutOrder: (order: SalesOrderDTO) => Promise<Result>
	}
}

Command.register('printTakeOutOrder', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_Print), Preconditions.ensureIsNotLite), async (order: SalesOrderDTO): Promise<Result> => {
	const options = await createPrintDocumentOptions(order);
	return printDocument({
		getOptions: () => options,
		print: async params => printOrder(order, params)
	});
});
